import { render, staticRenderFns } from "./Branches.vue?vue&type=template&id=58417bc8&scoped=true&"
import script from "./Branches.vue?vue&type=script&lang=js&"
export * from "./Branches.vue?vue&type=script&lang=js&"
import style0 from "./Branches.vue?vue&type=style&index=0&id=58417bc8&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58417bc8",
  null
  
)

component.options.__file = "Branches.vue"
export default component.exports